import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { api } from '../../api';
import { Wheel as RouWheel } from 'react-custom-roulette';
import { Howl } from 'howler';
import { Loader2 } from 'lucide-react';
import './Wheel.css';
import PrizeTable from '../../components/prizesTable/PrizeTable';
import PrimaryButton from '../../components/button/primaryButton';
import { Settings } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import UserInfoForm from '../../components/userInfoForm';
import WinnerModal from '../../components/winnerModal';
import { toast } from 'react-toastify';
import './Loader.css';
import zIndex from '@mui/material/styles/zIndex';
const logo = require('../../assets/logo.jpg');

const buttonStyle = {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "24px",
    color: '#fff'
};

const sound = new Howl({
    src: ['tick.mp3'],
    loop: false,
});

const backgroundColors = [
    "#FF6B6B", "#FFD93D", "#6BCB77", "#4D96FF", "#9B5DE5",
    "#F15BB5", "#00BBF9", "#00F5D4", "#A2D2FF", "#FEE440"
];
const textColors = ['#FFFFFF'];
const outerBorderColor = '#eeeeee';
const outerBorderWidth = 10;
const innerBorderColor = '#30261a';
const innerBorderWidth = 0;
const innerRadius = 0;
const radiusLineColor = '#eeeeee';
const radiusLineWidth = 8;
const fontFamily = 'Nunito';
const fontWeight = 'bold';
const fontSize = 16;
const fontStyle = 'normal';
const textDistance = 60;
const spinDuration = 1.0;

const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

export default function Wheel() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [mustSpin, setMustSpin] = useState(false);
    const [prizes, setPrizes] = useState([]);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [isShowModalInfo, setIsShowModalInfo] = useState(true);
    const userInfo = useRef();
    const [isShowModalWinner, setIsShowModalWinner] = useState(false);
    const winnnerMessage = useRef();

    const prizesDataWheel = useMemo(() => {

        if (prizes?.length > 0) {
            return prizes?.map(item => {
                return {
                    ...item,
                    option: truncateText(item.name)
                }
            });
        }

        return null;
    }, [prizes]);

    const showToast = useCallback(() => {
        toast.error("Liên hệ người quản trị giải thưởng kiểm tra danh sách, hiện tại không có giải thưởng nào có số lượng lớn hơn 0", {
            position: "top-right",
        });
    }, []);

    const fetchPrizes = useCallback(async () => {
        setLoading(true);
        const response = await api.get('/prizes');
        if (response?.data?.length === 0) {
            setIsShowModalInfo(false);
            setTimeout(() => {
                setLoading(false);


            }, 2000);
            return showToast();


        }
        setPrizes(response.data);
        setLoading(false);

    }, [setIsShowModalInfo, setLoading, setPrizes]);


    const handleCloseInfoModal = useCallback(async (data) => {
        userInfo.current = data;
        const { playerName = '', phone, address, vehical, noCCCD, branch } = data || {};

        const response = await api.post('/users',
            {
                username: playerName,
                phone,
                address,
                purchased_vehicle: vehical,
                cccd: noCCCD,
                branch
            }
        );
        setIsShowModalInfo(false);
    }, [setIsShowModalInfo, userInfo]);


    const disableScroll = useCallback(() => {
        document.body.style.overflow = "hidden";
    }, []);

    const enableScroll = useCallback(() => {
        document.body.style.overflow = "auto";
    }, []);

    const handleSpinClick = useCallback(async () => {
        try {
            if (!userInfo.current) {
                alert('Bạn cần điền thông tin người quay trước khi quay!');
                setIsShowModalInfo(true);
                return;
            }
            disableScroll();
            const response = await api.post('/spin', { user_name: userInfo.current?.playerName });
            const result = response.data;
            setPrizeNumber(result.index);
            setMustSpin(true);
            winnnerMessage.current = result?.message;
            let tickInterval = 150;
            let ticks = 0;
            const tickSound = setInterval(() => {
                sound.play();
                ticks++;
                if (ticks > 30) tickInterval += 10;
                if (ticks > 50) {
                    clearInterval(tickSound);
                    setTimeout(() => {
                        setIsShowModalWinner(true);
                        enableScroll();
                    }, 6000)
                }
            }, tickInterval);
        } catch (error) {
            console.error('Lỗi khi quay thưởng:', error);
            enableScroll()
        }
    }, [setPrizeNumber, setIsShowModalWinner, enableScroll, disableScroll, winnnerMessage, userInfo]);


    const handleSettingClick = useCallback(() => {
        navigate("/giaithuong")
    }, [navigate])


    useEffect(() => {
        fetchPrizes();
    }, []);

    const handleCloseWinnerModal = useCallback(() => {
        // setIsShowModalWinner(false);
        // fetchPrizes();
        // setTimeout(() => {
        //     setIsShowModalInfo(true);
        // }, 2000)

        // userInfo.current = {};
        // winnnerMessage.current = '';
        setTimeout(() => {
            window.location.reload();
        }, 2000)

    }, []);


    if (loading) return (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
    )

    return (
        <div className="flex flex-col items-center justify-content-center gradient-background">
            {isShowModalInfo && <UserInfoForm isShow={true} onSpin={handleCloseInfoModal} onClose={() => setIsShowModalInfo(false)} />}

            <WinnerModal
                isOpen={isShowModalWinner}
                onClose={handleCloseWinnerModal}
                text={winnnerMessage.current}
            />

            <div className='settingBtn'>
                <button style={buttonStyle} onClick={handleSettingClick}>
                    <Settings size={24} />
                </button>
            </div>

            <div className="rgba-background justify-content-center justify-items-center text-center">
                <div className='header'>
                    <h1 className="text-2xl font-bold mb-4">MUA XE HÔM NAY NHẬN NGAY QUÀ TẶNG</h1>
                </div>
            </div>

            <div className="two-columns justify-content-center" >
                <img src={logo} className='logoBC' />
                <div className="column justify-content-center justify-items-center text-center" style={{ position: 'absolute', top: '30%', right: -160, }}>
                    {prizesDataWheel && <PrimaryButton title={'Quay Ngay!'} onClick={handleSpinClick} />}

                    {prizesDataWheel?.length > 0 && <RouWheel
                        mustStartSpinning={mustSpin}
                        prizeNumber={prizeNumber || 0}
                        data={prizesDataWheel}
                        onStopSpinning={() => setMustSpin(false)}
                        backgroundColors={backgroundColors}
                        textColors={textColors}
                        fontFamily={fontFamily}
                        fontSize={fontSize}
                        fontWeight={fontWeight}
                        fontStyle={fontStyle}
                        outerBorderColor={outerBorderColor}
                        outerBorderWidth={outerBorderWidth}
                        innerRadius={innerRadius}
                        innerBorderColor={innerBorderColor}
                        innerBorderWidth={innerBorderWidth}
                        radiusLineColor={radiusLineColor}
                        radiusLineWidth={radiusLineWidth}
                        spinDuration={spinDuration}
                        textDistance={textDistance}
                    />}
                </div>
            </div>

            <div class="footer">
                <div class="marquee">
                    <span>Cơ sở 1: 86 Lê Duẩn - tt Khe Sanh</span>
                    <span>Cơ sở 2: 172 Lê Duẩn - tt Khe Sanh</span>
                    <span>Cơ sở 3: 115 Lê Duẩn - tt Khe Sanh</span>
                    <span>Cơ sở 4: 03 Lý Thường Kiệt, tt Lao Bảo</span>
                    <span>Cơ sở 5: 509 Lê Duẩn, tt Krông-Klang Đakrông</span>
                </div>
            </div>
        </div >
    );
}
